import FootballStatsCategory from "../../../stats/football-stats-category";
import FootballState from "../../../state/football-state";
import DriveService from "../../../../../services/drive-service";
import { getPatComplete } from "../../../utils/context-utils";
import FootballStringifier from "../../../../../services/stringifiers/football-stringifier";
import StatsRule from "../../../../common/stats-rule";

export default class PatPassStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.PatPass &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { summaryContext } =
            FootballStringifier.generateSummary(play, gameContext) || {};

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: fragment.passedBy.teamId,
            playerId: fragment.passedBy.id,
            driveId: await DriveService.resolveDriveId(play, gameContext),
            fragmentId: fragment.id,
            category: FootballStatsCategory.PAT_PASS,
            values: {
                code: gameContext?.gameConfig?.scoring?.runPAT,
                attempted: 1,
                completed:
                    play.historyContains(FootballState.PatCompleted) ||
                    getPatComplete(summaryContext, play.contextSnapshot, play)
                        ? 1
                        : 0
            }
        });
    }
}
